const menus = [
    {
        name: 'main',
        title: '基础组件',
        list: []
    },
    {
        name: 'subform',
        title: '子表单组件',
        list: []
    },
    {
        name: 'aide',
        title: '辅助组件',
        list: []
    },
    {
        name: 'layout',
        title: '布局组件',
        list: []
    },
];

export default menus;
